<template>
  <v-card ref="dragableCard" elevation="7" class="dragable-card-container" :style="dragableCardStyle">
    <v-toolbar elevation="5" density="compact">
      <span ref="dragicon" style="cursor: grab">
        <v-icon color="font" data-testid="paperToolbar.drag-icon">mdi-drag</v-icon>
      </span>
      <slot />
    </v-toolbar>
  </v-card>
</template>

<script setup lang="ts">
import { computed, onMounted, reactive, ref, watch } from "vue";
import { useDisplay } from "vuetify";
import { CardPosition } from "./utils/resizeCard";
import DragHandler from "./services/drag-handler";

const position = reactive<CardPosition>({
  xLeft: "unset",
  xRight: "unset",
  yTop: "unset",
  yBottom: "unset",
});

const dragableCardStyle = computed(() => ({
  left: position.xLeft,
  width: "fit-content",
  top: position.yTop,
}));

const { smAndUp } = useDisplay();
const isDraggable = ref(false);
const dragicon = ref(null);
const dragableCard = ref(null);

watch(smAndUp, (newVal: boolean) => {
  isDraggable.value = newVal;
});

onMounted(() => {
  isDraggable.value = smAndUp.value;
  const dragTarget = dragicon.value as HTMLElement;
  const dragContent = dragableCard.value?.$el || (dragableCard.value as HTMLElement);
  if (dragTarget && dragContent) {
    new DragHandler(dragTarget, dragContent, position).enableDragging();
  }
});
</script>

<style scoped>
.dragable-card-container {
  position: absolute;
  flex-grow: 0;
  z-index: 1;
}
</style>
